var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export var ModelNumbers;
(function (ModelNumbers) {
    ModelNumbers["Atdm0604"] = "-MEwcGPlXG9dOjkk74Sm";
    ModelNumbers["Atnd1061"] = "-N6nFQRApoNG-bIPeKU8";
})(ModelNumbers || (ModelNumbers = {}));
const allowedMuteTypes = [
    'arrayMic',
    'lineOutput',
    'micLineInput',
    'stereoInput',
    'stereoOutput',
];
const allowedVolumeTypes = [
    'lineOutput',
    'micLineInput',
    'stereoInput',
    'stereoOutput',
    'usbOutput',
];
const allowedTypes = {
    amplifier: allowedVolumeTypes,
    assistiveListeningMute: allowedMuteTypes,
    assistiveListeningMuteStatus: allowedMuteTypes,
    assistiveListeningVolume: allowedVolumeTypes,
    audioInputMute: allowedMuteTypes,
    audioInputMuteStatus: allowedMuteTypes,
    audioInputVolume: allowedVolumeTypes,
    mics: allowedMuteTypes,
    micsMuteStatus: allowedMuteTypes,
    overflowRoomMute: allowedMuteTypes,
    overflowRoomMuteStatus: allowedMuteTypes,
    overflowRoomVolume: allowedVolumeTypes,
    preset: ['preset'],
    receiveGain: [],
    soundReinforcementMute: allowedMuteTypes,
    soundReinforcementMuteStatus: allowedMuteTypes,
    soundReinforcementVolume: allowedVolumeTypes,
    telephony: [],
};
function faderToDb(fader) {
    if (fader <= 1) {
        return -120;
    }
    else if (fader <= 11) {
        return 2 * (fader - 1) - 120;
    }
    else if (fader <= 31) {
        return 1 * (fader - 11) - 100;
    }
    else if (fader <= 111) {
        return 0.5 * (fader - 31) - 80;
    }
    else if (fader <= 211) {
        return 0.2 * (fader - 111) - 40;
    }
    return 0.1 * (fader - 211) - 20;
}
function dbToFader(db) {
    if (db < -120) {
        return 0;
    }
    else if (db < -100) {
        return 0.5 * (db + 120) + 1;
    }
    else if (db < -80) {
        return 1 * (db + 100) + 11;
    }
    else if (db < -40) {
        return 2 * (db + 80) + 31;
    }
    else if (db < -20) {
        return 5 * (db + 40) + 111;
    }
    return 10 * (db + 20) + 211;
}
function isPresetMuteConfig(cfg) {
    return 'mutePreset' in cfg;
}
class Channel {
    constructor(type, index = undefined, indexInConfig = true, indexConfigOffset = 0) {
        this.type = type;
        this.index = index;
        this.indexInConfig = indexInConfig;
        this.indexConfigOffset = indexConfigOffset;
        this.isMuteConfigured = false;
        this.isVolumeConfigured = false;
        this.key = this.index !== undefined && this.indexInConfig ? `${type}.${this.index}` : type;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    detectName(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    getFader(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`fader not supported for ${this.key}`);
        });
    }
    getMute(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.type === 'usbOutput')
                return false; // TODO: fix this
            throw new Error(`mute not supported for ${this.key}`);
        });
    }
    loadPreset(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`preset not supported for ${this.key}`);
        });
    }
    matches(config) {
        if (config.type !== this.type)
            return false;
        if (this.index === undefined) {
            return !('channel' in config);
        }
        else {
            if (!this.indexInConfig)
                return !('channel' in config);
            return config.channel === this.index + this.indexConfigOffset;
        }
    }
    setFader(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`fader not supported for ${this.key}`);
        });
    }
    setMute(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            // Prevents a problem caused with 'removing: set.volumeMute' when usbOutput channel is used
            // for room Volume and volume goes to 0.
            if (this.type === 'usbOutput')
                return false; // TODO: fix this
            throw new Error(`mute not supported for ${this.key}`);
        });
    }
    isAllowed(filter) {
        return allowedTypes[filter].includes(this.type);
    }
}
class Channels {
    constructor() {
        this.channels = [];
    }
    get areAnyConfigured() {
        for (const channel of this.channels) {
            if (channel.isMuteConfigured || channel.isVolumeConfigured)
                return true;
        }
        return false;
    }
    detectNames(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const channel of this.channels) {
                yield channel.detectName(socket, tags);
            }
        });
    }
    getByKey(key) {
        return this.channels.find(channel => channel.key === key);
    }
    getChannel(config) {
        for (const channel of this.channels) {
            if (channel.matches(config))
                return channel;
        }
        return undefined;
    }
    getConfiguredChannels(control) {
        return this.channels.filter(channel => control === 'mute' ? channel.isMuteConfigured : channel.isVolumeConfigured);
    }
    getDetected() {
        const detectedChannels = [];
        for (const channel of this.channels) {
            const detectedChannel = {
                type: channel.type,
                filters: this.computeFilters(channel.type),
            };
            if (channel.index !== undefined &&
                channel.type !== 'stereoInput' &&
                channel.type !== 'stereoOutput') {
                // don't include channel for stereo input/output
                if (channel.type === 'preset') {
                    detectedChannel.channel = channel.index;
                }
                else {
                    detectedChannel.channel = channel.index + 1;
                }
            }
            if (channel.name)
                detectedChannel.name = channel.name;
            detectedChannels.push(detectedChannel);
        }
        return detectedChannels;
    }
    resetConfigured() {
        for (const channel of this.channels) {
            channel.isMuteConfigured = false;
            channel.isVolumeConfigured = false;
        }
    }
    computeFilters(type) {
        return {
            amplifier: allowedTypes.amplifier.includes(type),
            assistiveListeningMute: allowedTypes.assistiveListeningMute.includes(type),
            assistiveListeningMuteStatus: allowedTypes.assistiveListeningMuteStatus.includes(type),
            assistiveListeningVolume: allowedTypes.assistiveListeningVolume.includes(type),
            audioInputMute: allowedTypes.audioInputMute.includes(type),
            audioInputMuteStatus: allowedTypes.audioInputMuteStatus.includes(type),
            audioInputVolume: allowedTypes.audioInputVolume.includes(type),
            mics: allowedTypes.mics.includes(type),
            micsMuteStatus: allowedTypes.micsMuteStatus.includes(type),
            overflowRoomMute: allowedTypes.overflowRoomMute.includes(type),
            overflowRoomMuteStatus: allowedTypes.overflowRoomMuteStatus.includes(type),
            overflowRoomVolume: allowedTypes.overflowRoomVolume.includes(type),
            preset: type === 'preset',
            receiveGain: false,
            soundReinforcementMute: allowedTypes.soundReinforcementMute.includes(type),
            soundReinforcementMuteStatus: allowedTypes.soundReinforcementMuteStatus.includes(type),
            soundReinforcementVolume: allowedTypes.soundReinforcementVolume.includes(type),
            telephony: false,
        };
    }
}
class AtndChannels extends Channels {
    constructor() {
        super();
        this.channels.push(new DeviceMicChannel());
        // Microphone beams are 0 - 5 and analog input is input 6, but the input channel doesn't
        // support mute, so we don't add it to the channels object.
        for (let i = 0; i < 6; i++)
            this.channels.push(new InputChannel('micLineInput', i));
        // Line outputs are analog out (0) and automix output (1).
        for (let i = 0; i < 2; i++)
            this.channels.push(new OutputChannel('lineOutput', i));
        for (let i = 1; i < 16; i++)
            this.channels.push(new PresetChannel(i));
    }
}
class AtdmChannels extends Channels {
    constructor(detectedModel) {
        super();
        this.channels.push(new ArrayMicChannel());
        for (let i = 0; i < 6; i++)
            this.channels.push(new InputChannel('micLineInput', i));
        this.channels.push(new InputChannel('stereoInput', 10, false));
        for (let i = 0; i < 2; i++)
            this.channels.push(new OutputChannel('lineOutput', i));
        this.channels.push(new OutputChannel('stereoOutput', 10, false));
        this.channels.push(new UsbOutputChannel(detectedModel));
        for (let i = 1; i < 7; i++)
            this.channels.push(new PresetChannel(i));
    }
}
class ArrayMicChannel extends Channel {
    constructor() {
        super('arrayMic');
    }
    getMute(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send('g_arraymic_mute O 0000 00 NC', /^g_arraymic_mute 0000 00 NC (0|1)/, tags);
            return match[1] === '1';
        });
    }
    setMute(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield socket.send(`s_arraymic_mute S 0000 00 NC ${value ? '1' : '0'}`, /^s_arraymic_mute ACK/, tags);
            return value;
        });
    }
}
// global channel for overall system mute of the ATND-1061 array ceiling microphone
class DeviceMicChannel extends Channel {
    constructor() {
        super('arrayMic');
    }
    getMute(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send('g_mute O 0000 00 NC', /^g_mute 0000 00 NC (0|1)/, tags);
            return match[1] === '1';
        });
    }
    setMute(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield socket.send(`s_mute S 0000 00 NC ${value ? '1' : '0'}`, /^s_mute ACK/, tags);
            return value;
        });
    }
}
class InputChannel extends Channel {
    constructor(type, index, indexInConfig = true, indexConfigOffset = 1) {
        super(type, index, indexInConfig, indexConfigOffset);
    }
    detectName(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send(`g_input_channel_settings O 0000 00 NC ${this.index}`, new RegExp(`^g_input_channel_settings 0000 00 NC ${this.index},.+,"(.+)"`), tags);
            this.name = match[1];
        });
    }
    getMute(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send(`g_input_gain_level O 0000 00 NC ${this.index}`, new RegExp(`^g_input_gain_level 0000 00 NC ${this.index},\\d+,\\d+,(\\d+),\\d*,\\d*,(\\d+)`), tags);
            return match[2] === '1';
        });
    }
    getFader(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send(`g_input_gain_level O 0000 00 NC ${this.index}`, new RegExp(`^g_input_gain_level 0000 00 NC ${this.index},\\d+,\\d+,(\\d+),\\d*,\\d*,\\d*,(\\d+)`), tags);
            return faderToDb(parseInt(match[1], 10));
        });
    }
    setMute(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield socket.send(`s_input_gain_level S 0000 00 NC ${this.index},,,,,,${value ? '1' : '0'}`, new RegExp(`^s_input_gain_level ACK`), tags);
            return value;
        });
    }
    setFader(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield socket.send(`s_input_gain_level S 0000 00 NC ${this.index},,,${dbToFader(value)}`, new RegExp(`^s_input_gain_level ACK`), tags);
            return value;
        });
    }
}
class OutputChannel extends Channel {
    constructor(type, index, indexInConfig = true, indexConfigOffset = 1) {
        super(type, index, indexInConfig, indexConfigOffset);
    }
    detectName(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send(`g_output_channel_settings O 0000 00 NC ${this.index}`, new RegExp(`^g_output_channel_settings 0000 00 NC ${this.index},.*,"(.+)"`), tags);
            this.name = match[1];
        });
    }
    getMute(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send(`g_output_mute O 0000 00 NC ${this.index}`, new RegExp(`^g_output_mute 0000 00 NC ${this.index},(\\d+)`), tags);
            return match[1] === '1';
        });
    }
    getFader(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send(`g_output_level O 0000 00 NC ${this.index}`, new RegExp(`^g_output_level 0000 00 NC ${this.index},(\\d+),`), tags);
            return faderToDb(parseInt(match[1], 10));
        });
    }
    setMute(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield socket.send(`s_output_mute S 0000 00 NC ${this.index},${value ? '1' : '0'}`, new RegExp(`^s_output_mute ACK`), tags);
            return value;
        });
    }
    setFader(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield socket.send(`s_output_level S 0000 00 NC ${this.index},${dbToFader(value)}`, new RegExp(`^s_output_level ACK`), tags);
            return value;
        });
    }
}
class PresetChannel extends Channel {
    constructor(index) {
        super('preset');
        this.index = index;
    }
    detectName(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send(`g_name_bank O 0000 00 NC`, new RegExp(`^g_name_bank 0000 00 C[SME] ${this.index},"(.+)"`), tags);
            this.name = match[1];
        });
    }
    loadPreset(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield socket.send(`call_preset S 0000 00 NC ${this.index}`, /^call_preset ACK/, tags);
        });
    }
}
class UsbOutputChannel extends Channel {
    constructor(detectedModel) {
        super('usbOutput');
        this.detectedModel = detectedModel;
    }
    getFader(socket, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield socket.send('g_usb_out O 0000 00 NC', this.detectedModel === 'atdm0604'
                ? /^g_usb_out 0000 00 NC \d+,(\d+)/
                : /^g_usb_out 0000 00 NC \d+,\d+,(\d+)/, tags);
            return faderToDb(parseInt(match[1], 10));
        });
    }
    setFader(socket, value, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield socket.send(this.detectedModel === 'atdm0604'
                ? `s_usb_out S 0000 00 NC 0,${dbToFader(value)}`
                : `s_usb_out S 0000 00 NC 0,0,${dbToFader(value)}`, /^s_usb_out (ACK|NAK)/, tags);
            return value;
        });
    }
}
export class Atdm0604 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        // other class properties and constructor
        this.channelPollIndex = 0;
        this.channelPolls = [];
        this.channels = new AtdmChannels('atdm0604');
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'identify S 0000 00 NC',
                succeed: /^identify (ACK|NAK)/,
            },
        ];
        // controls
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                // TODO: detect asynchronous name changes
                yield this.channels.detectNames(this.socket, tags);
                return this.channels.getDetected();
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('g_firmware_version O 0000 00 NC', /^g_firmware_version 0000 00 NC (\S+)/, tags);
                return match[1];
            }),
        };
        this.mute = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const channel = this.channels.getByKey(key);
                if (channel === undefined)
                    throw new Error(`no channel for key = ${key}`);
                return yield channel.getMute(this.socket, tags);
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const channel = this.channels.getByKey(key);
                if (channel === undefined)
                    throw new Error(`no channel for key = ${key}`);
                if (channel.presetMute === undefined) {
                    return yield channel.setMute(this.socket, value, tags);
                }
                else {
                    if (value) {
                        yield channel.presetMute.mute.loadPreset(this.socket, tags);
                    }
                    else {
                        yield channel.presetMute.unmute.loadPreset(this.socket, tags);
                    }
                    return value;
                }
            }),
            getKey: this.getKey.bind(this),
            validate: this.validate.bind(this), // happens before constructor binding
        };
        this.volume = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const channel = this.channels.getByKey(key);
                if (channel === undefined)
                    throw new Error(`no channel for key = ${key}`);
                return yield channel.getFader(this.socket, tags);
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const channel = this.channels.getByKey(key);
                if (channel === undefined)
                    throw new Error(`no channel for key = ${key}`);
                yield this.syncVolumeMute(channel, value);
                return yield channel.setFader(this.socket, value, tags);
            }),
            getKey: this.getKey.bind(this),
            range: (config, info) => __awaiter(this, void 0, void 0, function* () {
                if (info.volumeType === 'trim') {
                    if (config.type === 'usbOutput') {
                        return { max: 0, min: -20, round: 1 };
                    }
                    else {
                        return { max: 10, min: -14, round: 1 };
                    }
                }
                if (config.type === 'usbOutput') {
                    return { max: 0, min: -50, round: 1 };
                }
                else {
                    return { max: 10, min: -40, round: 1 };
                }
            }),
            validate: this.validate.bind(this), // happens before constructor binding
        };
        // polling
        this.polls = [
            {
                intervalMs: 3000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    if (this.channelPolls.length > 0) {
                        yield ((_b = (_a = this.channelPolls)[this.channelPollIndex]) === null || _b === void 0 ? void 0 : _b.call(_a));
                        this.channelPollIndex++;
                        if (this.channelPollIndex >= this.channelPolls.length) {
                            this.channelPollIndex = 0;
                        }
                    }
                    else {
                        yield this.firmwareVersion.get(['firmwareVersion', 'poll']);
                    }
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.volumeConfig = undefined;
            const tags = ['configuring'];
            if (config.equipmentType === ModelNumbers.Atdm0604) {
                // Determine if this is an ATDM-0604 or newer ATDM-0604A. The 0604A has an additional
                // parameter for the g_usb_out response and s_usb_out commands.
                let model = 'atdm0604';
                try {
                    const resp = yield this.socket.send(`g_usb_out O 0000 00 NC`, /g_usb_out 0000 00 NC (\d+),(\d+),?(\d+)?/i, tags);
                    if (resp.length > 3) {
                        model = 'atdm0604a';
                    }
                }
                catch (_a) { }
                this.channels = new AtdmChannels(model);
            }
            else if (config.equipmentType === ModelNumbers.Atnd1061) {
                // take the microphone out of power save mode
                yield this.socket.send(`s_powersave S 0000 00 NC 0`, /s_powersave (ACK|NAK)/i, tags);
                this.channels = new AtndChannels();
            }
            else {
                this.log.error(`Invalid equipment type.`);
            }
        });
    }
    onControl() {
        return __awaiter(this, void 0, void 0, function* () {
            this.channelPolls.length = 0;
            this.channelPollIndex = 0;
            for (const channel of this.channels.getConfiguredChannels('mute')) {
                this.channelPolls.push(() => __awaiter(this, void 0, void 0, function* () {
                    const value = yield channel.getMute(this.socket, [
                        `get.mute.${channel.key}`,
                        'poll',
                    ]);
                    this.state.mutes.update(channel.key, value);
                }));
            }
            for (const channel of this.channels.getConfiguredChannels('volume')) {
                this.channelPolls.push(() => __awaiter(this, void 0, void 0, function* () {
                    const value = yield channel.getFader(this.socket, [
                        `get.volume.${channel.key}`,
                        'poll',
                    ]);
                    this.state.volumes.update(channel.key, value);
                }));
            }
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    hasRoomVolumeMute() {
        return this.volumeConfig === undefined
            ? false
            : allowedMuteTypes.includes(this.volumeConfig.type);
    }
    getKey(config) {
        if (isPresetMuteConfig(config))
            return this.getKey(config.muteStatus);
        const channel = this.channels.getChannel(config);
        if (channel === undefined) {
            return 'channel' in config
                ? `invalid.${config.type}.${config.channel}`
                : `invalid.${config.type}`;
        }
        return channel.key;
    }
    syncVolumeMute(channel, volume) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.volumeConfig === undefined || !this.hasRoomVolumeMute())
                return;
            const key = this.getKey(this.volumeConfig);
            const newVolumeMute = volume <= -40;
            if (channel.key !== key)
                return;
            if (this.state.mutes.values[key] !== newVolumeMute) {
                const value = yield this.mute.set(key, newVolumeMute, ['set.volumeMute']);
                this.state.mutes.update(key, value);
            }
        });
    }
    validate(config, info) {
        return __awaiter(this, void 0, void 0, function* () {
            if (info.type === 'volume' && info.filter === 'amplifier') {
                this.volumeConfig = config;
            }
            if (isPresetMuteConfig(config)) {
                if (config.mutePreset.type !== 'preset' || config.mutePreset.channel === undefined) {
                    return 'incompatible';
                }
                if (config.unmutePreset.type !== 'preset' ||
                    config.unmutePreset.channel === undefined) {
                    return 'incompatible';
                }
                const mutePresetChannel = this.channels.getChannel(config.mutePreset);
                const unmutePresetChannel = this.channels.getChannel(config.unmutePreset);
                if (mutePresetChannel === undefined)
                    return 'missing';
                if (unmutePresetChannel === undefined)
                    return 'missing';
                const channel = this.channels.getChannel(config.muteStatus);
                if (channel === undefined)
                    return 'missing';
                if (!channel.isAllowed(info.filter))
                    return 'incompatible';
                channel.isMuteConfigured = true;
                channel.presetMute = { mute: mutePresetChannel, unmute: unmutePresetChannel };
                return 'ok';
            }
            else {
                const channel = this.channels.getChannel(config);
                if (channel === undefined)
                    return 'missing';
                if (!channel.isAllowed(info.filter))
                    return 'incompatible';
                if (info.type === 'volume') {
                    channel.isVolumeConfigured = true;
                    if (config === this.volumeConfig &&
                        allowedMuteTypes.includes(this.volumeConfig.type)) {
                        channel.isMuteConfigured = true;
                    }
                }
                else if (info.type === 'mute') {
                    if (channel.type !== 'usbOutput') {
                        // usbOutput doesn't support mute
                        channel.isMuteConfigured = true;
                    }
                }
                return 'ok';
            }
        });
    }
}
// static properties
Atdm0604.channelsConfigName = 'atdm0604ControlChannels';
Atdm0604.driverType = 'socketDriver';
Atdm0604.key = '-MEwcGPlXG9dOjkk74Sm';
Atdm0604.socketOptions = [
    {
        commandExtractor: {
            terminators: ['\r'],
        },
        port: 17300,
        sendTerminator: ' \r', // all ATDM-0604 commands have a space before the CR
    },
];
